import React, { useState } from "react";
import { Link } from "react-router-dom";
import constructionLogo from "../../pictures/velvizhi_logo_main.png";

import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Typography,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

function NavbarHeader() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuType, setMenuType] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [aboutOpen, setAboutOpen] = useState(false);
  const [projectsOpen, setProjectsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const handleOpen = (event, menu) => {
    setAnchorEl(event.currentTarget);
    setMenuType(menu);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuType(null);
  };

  const toggleDrawer = () => {
    setMobileOpen((prev) => !prev);
  };

  const closeDrawer = () => {
    setMobileOpen(false);
  };

  const navButtonSx = {
    color: "#0d0651",
    fontWeight: 600,
    fontSize: "0.95rem",
    px: 1,
    minWidth: "auto",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#3b2bb3",
    },
  };

  const menuSx = {
    "& .MuiPaper-root": {
      mt: 1.5,
      borderRadius: 3,
      minWidth: 220,
      boxShadow: "0 14px 32px rgba(0,0,0,0.12)",
      border: "1px solid rgba(13, 6, 81, 0.08)",
    },
  };

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          background: "rgba(230, 228, 228, 0.95)",
          backdropFilter: "blur(12px)",
          color: "#0d0651",
          borderBottom: "1px solid rgba(13, 6, 81, 0.08)",
        }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 78, md: 92 },
            px: { xs: 2, sm: 3, md: 5 },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          {/* LOGO + BRAND */}
          {/* UPDATED LOGO + BRAND */}
          <Box
  component={Link}
  to="/"
  sx={{
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    gap: { xs: 0.5, sm: 1 }, // Reduced gap
    flexShrink: 1,
    minWidth: 0,
  }}
>
  <Box
    component="img"
    src={constructionLogo}
    alt="Velvizhi Construction Logo"
    sx={{
      backgroundColor: "rgba(230, 228, 228, 0.95)",
      height: { xs: 50, sm: 70, md: 100 },
      width: "auto",
      objectFit: "contain",
      flexShrink: 0,
    }}
  />

  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: 0,
    }}
  >
    <Typography
      sx={{
        color: "#0d0651",
        fontWeight: 800,
        lineHeight: 1,
        fontFamily: "'Playfair Display', serif",
        fontSize: {
          xs: "1.1rem",
          sm: "1.5rem",
          md: "1.7rem",
        },
        letterSpacing: "0.5px",
        textAlign: "center",
        whiteSpace: "nowrap",
      }}
    >
      Velvizhi Construction
    </Typography>

    <Typography
      sx={{
        color: "#2d2d2d",
        fontSize: {
          xs: "0.65rem",
          sm: "0.8rem",
          md: "0.95rem",
        },
        fontStyle: "italic",
        fontWeight: 500,
        mt: 0.3,
        textAlign: "center",
        letterSpacing: "1px",
      }}
    >
      Built to Build and Build
    </Typography>
  </Box>
</Box>

          {/* DESKTOP MENU */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: 2,
            }}
          >
            <Button component={Link} to="/" sx={navButtonSx}>
              HOME
            </Button>

            <Button
              onClick={(e) => handleOpen(e, "about")}
              sx={navButtonSx}
              endIcon={<ArrowDropDownIcon />}
            >
              ABOUT
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={menuType === "about"}
              onClose={handleClose}
              sx={menuSx}
            >
              <MenuItem
                component={Link}
                to="/company-profile"
                onClick={handleClose}
              >
                Profile
              </MenuItem>
              <MenuItem component={Link} to="/team" onClick={handleClose}>
                Our Team
              </MenuItem>
              <MenuItem component={Link} to="/careers" onClick={handleClose}>
                Careers
              </MenuItem>
            </Menu>

            <Button
              onClick={(e) => handleOpen(e, "projects")}
              sx={navButtonSx}
              endIcon={<ArrowDropDownIcon />}
            >
              PROJECTS
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={menuType === "projects"}
              onClose={handleClose}
              sx={menuSx}
            >
              <MenuItem
                component={Link}
                to="/completed-projects"
                onClick={handleClose}
              >
                Completed Projects
              </MenuItem>
              <MenuItem
                component={Link}
                to="/ongoing-projects"
                onClick={handleClose}
              >
                Ongoing Projects
              </MenuItem>
            </Menu>

            <Button
              onClick={(e) => handleOpen(e, "services")}
              sx={navButtonSx}
              endIcon={<ArrowDropDownIcon />}
            >
              SERVICES
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={menuType === "services"}
              onClose={handleClose}
              sx={menuSx}
            >
              <MenuItem
                component={Link}
                to="/construction"
                onClick={handleClose}
              >
                Construction
              </MenuItem>
              <MenuItem
                component={Link}
                to="/architecture"
                onClick={handleClose}
              >
                Architecture
              </MenuItem>
              <MenuItem
                component={Link}
                to="/interior-design"
                onClick={handleClose}
              >
                Interior Design
              </MenuItem>
            </Menu>

            <Button component={Link} to="/construction-plans" sx={navButtonSx}>
              CONSTRUCTION PLANS
            </Button>

            <Button component={Link} to="/contact-us" sx={navButtonSx}>
              CONTACT US
            </Button>

            <Button component={Link} to="/reviews" sx={navButtonSx}>
              CLIENTS CORNER
            </Button>
          </Box>

          {/* MOBILE MENU ICON */}
          <IconButton
            sx={{
              display: { xs: "flex", md: "none" },
              color: "#0d0651",
              border: "1px solid rgba(13, 6, 81, 0.12)",
              borderRadius: 2,
            }}
            onClick={toggleDrawer}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* MOBILE DRAWER */}
      <Drawer anchor="left" open={mobileOpen} onClose={toggleDrawer}>
        <Box
          sx={{
            width: 280,
            height: "100%",
            background: "#fff",
            color: "#0d0651",
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 2.5,
              borderBottom: "1px solid rgba(13, 6, 81, 0.08)",
            }}
          >
            <Typography
              fontWeight="bold"
              sx={{
                color: "#0d0651",
                fontFamily: "'Playfair Display', 'Poppins', sans-serif",
                fontSize: "1.25rem",
                textAlign: "center",
              }}
            >
              Velvizhi Construction
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#555",
                mt: 0.5,
                justifyContent: "center",
                display: "flex",
              }}
            >
              Built to Build and Build
            </Typography>
          </Box>

          <List sx={{ py: 1 }}>
            <ListItemButton component={Link} to="/" onClick={closeDrawer}>
              <ListItemText primary="HOME" />
            </ListItemButton>

            <ListItemButton onClick={() => setAboutOpen((prev) => !prev)}>
              <ListItemText primary="ABOUT" />
              {aboutOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={aboutOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/company-profile"
                  onClick={closeDrawer}
                >
                  <ListItemText primary="Profile" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/team"
                  onClick={closeDrawer}
                >
                  <ListItemText primary="Our Team" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/careers"
                  onClick={closeDrawer}
                >
                  <ListItemText primary="Careers" />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton onClick={() => setProjectsOpen((prev) => !prev)}>
              <ListItemText primary="PROJECTS" />
              {projectsOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={projectsOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/completed-projects"
                  onClick={closeDrawer}
                >
                  <ListItemText primary="Completed Projects" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/ongoing-projects"
                  onClick={closeDrawer}
                >
                  <ListItemText primary="Ongoing Projects" />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton onClick={() => setServicesOpen((prev) => !prev)}>
              <ListItemText primary="SERVICES" />
              {servicesOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={servicesOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/construction"
                  onClick={closeDrawer}
                >
                  <ListItemText primary="Construction" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/architecture"
                  onClick={closeDrawer}
                >
                  <ListItemText primary="Architecture" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/interior-design"
                  onClick={closeDrawer}
                >
                  <ListItemText primary="Interior Design" />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton
              component={Link}
              to="/construction-plans"
              onClick={closeDrawer}
            >
              <ListItemText primary="CONSTRUCTION PLANS" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/contact-us"
              onClick={closeDrawer}
            >
              <ListItemText primary="CONTACT US" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/reviews"
              onClick={closeDrawer}
            >
              <ListItemText primary="CLIENTS CORNER" />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
    </>
  );
}

export default NavbarHeader;
